/** Spanish geometry prompts and classification vocabulary (ADR 0051 part 3). */
export const geometryPrompts = {
    classifyAngle: (measure: number) =>
        `Un ángulo mide ${measure}°. ¿Es agudo, recto, obtuso o llano?`,
    missingAngleTriangle: (a: number, b: number) =>
        `Dos ángulos de un triángulo miden ${a}° y ${b}°. ¿Cuál es el tercer ángulo?`,
    missingAngleLine: (a: number) =>
        `Dos ángulos están sobre una línea recta. Uno mide ${a}°. ¿Cuál es el otro?`,
    missingAnglePoint: (a: number, b: number) =>
        `Tres ángulos se juntan en un punto. Dos miden ${a}° y ${b}°. ¿Cuál es el tercero?`,
    complement: (given: number) => `¿Cuál es el complemento de ${given}°?`,
    supplement: (given: number) => `¿Cuál es el suplemento de ${given}°?`,
    classifyTriangle: (a: number, b: number, c: number) =>
        `Un triángulo tiene lados de ${a} cm, ${b} cm y ${c} cm. ¿Es escaleno, isósceles o equilátero?`,
    polygonSidesFromName: (name: string) => `¿Cuántos lados tiene un ${name}?`,
    polygonNameFromSides: (sides: number) => `¿Cómo se llama un polígono de ${sides} lados?`,
};

export const angleClassLabels: Record<'acute' | 'right' | 'obtuse' | 'straight', string> = {
    acute: 'agudo',
    right: 'recto',
    obtuse: 'obtuso',
    straight: 'llano',
};

export const triangleClassLabels: Record<'equilateral' | 'isosceles' | 'scalene', string> = {
    equilateral: 'equilátero',
    isosceles: 'isósceles',
    scalene: 'escaleno',
};

export const polygonNames: Record<number, string> = {
    3: 'triángulo',
    4: 'cuadrilátero',
    5: 'pentágono',
    6: 'hexágono',
    7: 'heptágono',
    8: 'octágono',
    9: 'eneágono',
    10: 'decágono',
};
